import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import SmsIcon from '@material-ui/icons/Sms'
import SubscriptionsIcon from '@material-ui/icons/Subscriptions'
import SimCardIcon from '@material-ui/icons/SdCard'
import DataUsageIcon from '@material-ui/icons/DataUsage'
import GroupIcon from '@material-ui/icons/Group'
import SignalCellular3BarIcon from '@material-ui/icons/SignalCellular3Bar'
import SpeakerPhoneIcon from '@material-ui/icons/SpeakerPhone'
import Styles from '../../../common/styles'
import { connect } from 'react-redux'
import Moment from 'moment'
import { bindActionCreators } from 'redux'
import * as adminActions from '../../../store/admin'
import { Bar, Line } from 'react-chartjs-2'
import Y from '../../../y18n'
import { DatePicker } from 'material-ui-pickers'
import { TextField } from '@material-ui/core'


const mapStateToProps = state => ({
  metrics: state.admin.metrics,
  filter: state.admin.filter
})

const mapDispatchToProps = dispatch => ({
  adminActions: bindActionCreators(adminActions, dispatch)
})

const GroupByEnum = Object.freeze({days: 0, months: 1, years: 2})
const GroupByValues = Object.freeze([
  {
    value: GroupByEnum.days,
    label: `Days`
  },
  {
    value: GroupByEnum.months,
      label: `Months`
  },
  {
    value: GroupByEnum.years,
    label: `Years`
  }
])

class HangfireStatus extends React.Component {
  componentDidMount () {
    this.props.adminActions.getMetrics(this.props.filter)
  }

  handleFromDateChange = date => {
    this.props.adminActions.setFilter('from', date.format('YYYY-MM-DD'))
    this.props.adminActions.getMetrics(this.props.filter)
  }

  handleToDateChange = date => {
    this.props.adminActions.setFilter('to', date.format('YYYY-MM-DD'))
    this.props.adminActions.getMetrics(this.props.filter)
  }

  handleGroupByChange = event =>{
    this.props.adminActions.setFilter('orderBy', event.target.value)
    this.props.adminActions.getMetrics()
  }

  getChartData (metrics, label, type, color) {
    return {
      labels: metrics.map(m => Moment.utc(m.timestamp).local().format('YYYY-MM-DD')),
      datasets: [
        {
          label,
          data: metrics.map(m => m[type]),
          backgroundColor: `${color}33`,
          borderColor: color,
          borderWidth: 1,
          pointBackgroundColor: color,
          hoverBackgroundColor: `${color}66`,
          hoverBorderColor: color,
          lineTension: 0
        }
      ]
    }
  }

  getChartAverageData (metrics, label, type1, type2, color){
    let x = {
      labels: metrics.map(m => Moment.utc(m.timestamp).local().format('YYYY-MM-DD')),
      datasets: [
        {
          label,
          data: metrics.map(m => m[type1]/m[type2]),
          backgroundColor: `${color}33`,
          borderColor: color,
          borderWidth: 1,
          pointBackgroundColor: color,
          hoverBackgroundColor: `${color}66`,
          hoverBorderColor: color,
          lineTension: 0
        }
      ]
    }
    return x
  }

  render () {
    const { metrics, classes, theme, filter} = this.props
    const options = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              min: 0
            }
          }
        ]
      }
    }

    if (!metrics || !metrics.metricData || !metrics.metricData.length) return null
    const { simcards, activeSimcards, smsActiveSimcards, dataUsed, smsUsed, users, subscriptions, timestamp } = metrics
    return (
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <DatePicker
            keyboard
            clearable
            className={classes.flexItemLeft}
            animateYearScrolling={false}
            label={Y`From date`}
            format='YYYY-MM-DD'
            value={filter.from}
            onChange={this.handleFromDateChange}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: classes.root,
                input: classes.input
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.formLabel
            }}
            InputAdornmentProps={{
              classes: {
                root: classes.rightIcon
              }
            }}/>
          <DatePicker
            keyboard
            clearable
            className={classes.flexItemLeft}
            animateYearScrolling={false}
            label={Y`To date`}
            format='YYYY-MM-DD'
            value={filter.to}
            onChange={this.handleToDateChange}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: classes.root,
                input: classes.input
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.formLabel
            }}
            InputAdornmentProps={{
              classes: {
                root: classes.rightIcon
              }
            }}/>
          <TextField label={Y`GroupBy`}
                     select={true}
                     SelectProps={{
                       native: true
                     }}
                     defaultValue={filter.orderBy}
                     onChange={this.handleGroupByChange}>
            {GroupByValues.map((option) => (
              <option key={option.value} value={option.value}>
                {Y`${option.label}`}
              </option>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <Typography align='center' variant='title' style={{ fontSize: '32px' }}>{Y`Users`}</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classes.paper} style={{ padding: '16px 8px' }}>
            {
              metrics.metricData.length <= 722 ?
              <Bar
                data={this.getChartData(metrics.metricData, Y`New users`, 'newUsers', theme.palette.primary.main)}
                options={options}
              /> : <Line
                  data={this.getChartData(metrics.metricData, Y`New users`, 'newUsers', theme.palette.primary.main)}
                  options={options}
                />
            }
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classes.paper} style={{ padding: '16px 8px' }}>
            <Line data={this.getChartData(metrics.metricData, Y`Total users`, 'users', theme.palette.primary.main) } />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Typography
            align='center'
            variant='title'
            style={{ fontSize: '32px', marginTop: '40px' }}
          >{Y`Subscriptions`}</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classes.paper}>
            <Bar
              data={this.getChartData(metrics.metricData, Y`New subscriptions`, 'newSubscriptions', '#92bed2')}
              options={options}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classes.paper}>
            <Line data={this.getChartData(metrics.metricData, Y`Total subscriptions`, 'subscriptions', '#92bed2')} />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classes.paper}>
            <Line data={this.getChartAverageData(metrics.metricData, Y`Average data usage`, 'dataUsed', 'subscriptions', '#92bed2')} />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classes.paper}>
            <Line data={this.getChartData(metrics.metricData, Y`Data usage`, 'dataUsed', '#92bed2')} />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classes.paper}>
            <Line data={this.getChartAverageData(metrics.metricData, Y`Average sms usage`, 'smsUsed', 'subscriptions', '#92bed2')} />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classes.paper}>
            <Line data={this.getChartData(metrics.metricData, Y`Sms usage`, 'smsUsed', '#92bed2')} />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Typography
            align='center'
            variant='title'
            style={{ fontSize: '32px', marginTop: '40px' }}
          >{Y`Metrics`}</Typography>
          <Typography variant='body2' align='center'>
            {`${Y`Metrics from`} ${Moment(timestamp).format('YYYY-MM-DD')}`}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            <div><GroupIcon /></div>
            {Y`Users`}
            <Typography variant='display1'>{users}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            <div><SimCardIcon /></div>
            {Y`Simcards`}
            <Typography variant='display1'>{simcards}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            <div><SubscriptionsIcon /></div>
            {Y`Subscriptions`}
            <Typography variant='display1'>{subscriptions}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <div><DataUsageIcon /></div>
            {Y`Data used (MB)`}
            <Typography variant='display1'>{dataUsed}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <div><DataUsageIcon /></div>
            {Y`Average data used (MB) per subscription`}
            <Typography variant='display1'>{(dataUsed / subscriptions).toFixed(2)}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <div><SmsIcon /></div>
            {Y`SMS Sent`}
            <Typography variant='display1'>{smsUsed}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <div><SmsIcon /></div>
            {Y`Average SMS sent per subscription`}
            <Typography variant='display1'>{(smsUsed / subscriptions).toFixed(2)}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper}>
            <div><SignalCellular3BarIcon /></div>
            {Y`Active simcards`}
            <Typography variant='display1'>{activeSimcards}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper}>
            <div><SpeakerPhoneIcon /></div>
            {Y`SMS active simcards`}
            <Typography variant='display1'>{smsActiveSimcards}</Typography>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}
HangfireStatus = connect(mapStateToProps, mapDispatchToProps)(HangfireStatus)
export default withStyles(Styles, { withTheme: true })(HangfireStatus)



// WEBPACK FOOTER //
// ./src/pages/admin/containers/metrics.js